import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SideListOptionType } from '@fi-shared/types/side-list-option-type';
import { DocumentService } from '../document.service';
import { getSideListOptionsBottomFn } from '@fi-shared/fi-items-list/side-list-options';
import { DocumentListData, DocumentListDataService } from '../document-list-data-service';
import { IItemsListParams, ItemsListContainerBase } from '../../components/items-list-container-base';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiLocalSearchParameterModel } from '@fi-shared/fi-local-search2/fi-local-search-parameter.model';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiTagsListPositionTypes } from '@fi-app/components/items-list/enums';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { takeUntil } from 'rxjs/operators';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IItemsListAction2, ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { ItemsListComponent } from '@fi-app/components/items-list/items-list.component';
import { isNullOrUndefined } from 'util';
import { AccessRightType, ApplicationSettingsType, ModuleType } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { IItemsListFilter } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-filter';
import { FiItemsListFilterService } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.service';
import { FiAppSettings } from '@fi-shared/fi-app-settings';
import { fiItemsListTypeNameTextId } from '@fi-shared/utils/fi-items-list-type-name-text-id';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-document-list-view',
    templateUrl: './document-list-view.component.html',
    styleUrls: ['./document-list-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-list-view' },
    standalone: false,
})
export class DocumentListViewComponent extends ItemsListContainerBase<DocumentListData> implements OnInit {
    @Input() documentListViewSettings: ListViewSettingModel;
    @Input() isSideListShown: boolean = true;
    @Input() isItemActionsShown: boolean = false;
    @Input() listParams: IItemsListParams;
    @Input() tagIds: number[] = [];
    @Input() isFavoriteIconShown: boolean = true;
    @ViewChild(ItemsListComponent, { static: false }) itemsListComponent: ItemsListComponent;

    DocumentOptionsTop: ISideListOptionsItem[] = [];
    DocumentOptionsBottom: ISideListOptionsItem[] = [];
    DocumentOptionsTags: ISideListOptionsItem[] = [];
    actions: IItemsListAction2[] = [];

    FiStateNames = FiStateNames;
    FiItemsListType = FiItemsListType;

    currentFilter: IItemsListFilter;
    isFilterSettingsShown: boolean;

    private _loading$ = new BehaviorSubject(true);
    protected get loading$() {
        return this._loading$.asObservable();
    }

    constructor(
        private documentService: DocumentService,
        private documentListDataService: DocumentListDataService,
        private stateAccessCheckService: StateAccessCheckService,
        private appTextService: AppTextService,
        private detectDevices: DetectDevicesService,
        private fiSignalRHelperService: FiSignalRHelperService,
        private stateService: FiStateService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private tabsModuleService: TabsModuleService,
        private itemsListFilterService: FiItemsListFilterService,
    ) {
        super();
    }

    ngOnInit() {
        this.currentFilter = this.itemsListFilterService.getFilter(ModuleType.Document);
        this.isSuperAdminAccess = this.itemsListFilterService.getIsSuperAdminAccess(ModuleType.Document);
        this.isFilterSettingsShown = this.itemsListFilterService.getIsFilterSettingsShown(ModuleType.Document);

        this.reloadListSubscription();
        if (isNullOrUndefined(this.listParams)) this.listParams = Object.assign({}, { showDelete: false });

        this.initDocumentOptionsTopBottom();
        this.listParams.defaultFilterTypeFn = () => this.DocumentOptionsTop[0].value;
        super.onInit(() => {
            return this.documentListDataService.getInstance({
                isFavoriteIconShown: this.isFavoriteIconShown,
            });
        }, this.listParams);

        this.ListData.ListViewSettings = this.documentListViewSettings;
        this.ListData.ListViewSettings.PositionType = undefined;

        // if (this.ListData.Statefull) {
        //     const shouldGoToAll = (this.stateService.params.filterType == SideListOptionType.OnlyNotSeen && this.stateService.isHistoryBack
        //       && this.fiSignalRHelperService.getNewDocumentIdsCount() === 0);
        //     if (shouldGoToAll)
        //         super.SideListItemClick(SideListOptionType.SharedWithMe);
        // }

        this.ListData.ListViewSettings.prepareTagsForList(() => this.documentService.GetDocumentTags()).then(() => {
            this.initSideList();
            this._loading$.next(false);
        });

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });

        // invoke this for show/hide super admin column
        super.checkApplySuperAdminRight(this.hasSuperAdminRights(), [], undefined);
    }

    hasSuperAdminRights(): boolean {
        return this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.DocumentGlobal,
            AccessRightType.SuperAdmin,
        );
    }

    onSuperAdminToggleChange() {
        this.onFilterSettingsChanged();
        this.onItemsListFilterChanged(this.currentFilter);
    }

    private initDocumentOptionsTopBottom() {
        this.DocumentOptionsTop = [
            { value: SideListOptionType.SharedWithMe, text: this.appTextService.get('common.shared_with_me') },
            { value: SideListOptionType.New, text: this.appTextService.get('new_pages') },
            { value: SideListOptionType.OnlyNotVisited, text: this.appTextService.get('document.unread_pages') },
            { value: SideListOptionType.CreatedBy, text: this.appTextService.get('common.created_by_me') },
            { value: SideListOptionType.Favorite, text: this.appTextService.get('common.my_favorites') },
            { value: SideListOptionType.Deleted, text: this.appTextService.get('common.trash') },
        ];

        this.DocumentOptionsBottom = getSideListOptionsBottomFn(this.appTextService);
    }

    private initSideList(): void {
        this.DocumentOptionsTags = this.getSideListOptionsTags();
    }

    private reloadListSubscription() {
        this.documentService.reloadDocumentList$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.ListData.clearData();
            this.ListData.Initialize();
        });
    }

    IsTagSelected(tagId: number) {
        return this.ListData.selectedTags && this.ListData.selectedTags.indexOf(tagId) >= 0;
    }

    GetDocumentParameter() {
        const documentParameter = new FiLocalSearchParameterModel();

        Object.assign(documentParameter, this.ListData.getOffsetParams());

        documentParameter.SelectedSort = {
            ColumnName: this.ListData.Sort.Column,
            SortDirection: this.ListData.Sort.Reverse,
        };

        documentParameter.TagIds = this.tagIds.slice();
        documentParameter.FilterType = this.ListData.FilterType;

        if (this.ListData.selectedTags)
            this.ListData.selectedTags.forEach((tagId: number) => documentParameter.TagIds.push(tagId));

        this.ListData.mergeLocalSearchV2Parameter(documentParameter);

        documentParameter.IsSuperAdminAccess = this.isSuperAdminAccess;
        documentParameter.FilterSettings = this.currentFilter.Settings;

        return documentParameter;
    }

    private loading = false;
    protected LoadItems() {
        this.loading = true;
        const fetchingAllData = this.ListData.fetchingAllData;
        const parameter = this.GetDocumentParameter();
        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: fetchingAllData,
            FetchLightWeightObjects: fetchingAllData,
        };
        return this.documentService
            .getDocumentsListData(parameter)
            .then((response) => {
                this.ListData.InitializeData(response.Items);

                if (fetchingAllData) {
                    this.ListData.SetTotalItemsCount(response.TotalCount);

                    const lightWeightObjectCollection = response.LightWeightObjectsForLocalSearch;
                    if (lightWeightObjectCollection) {
                        this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
                    }
                }
            })
            .finally(() => (this.loading = false));
    }

    onItemsListFilterChanged($event: IItemsListFilter) {
        this.onFilterSettingsChanged();

        this.currentFilter = $event;
        const filterType =
            $event.Settings.CategoryFilterTypes.concat($event.Settings.ChangedOnFilterType)[0] ??
            SideListOptionType.SharedWithMe;
        this.SetFilterType(filterType);
    }

    onFilterSettingsChanged() {
        this.itemsListFilterService.onFilterSettingsChanged(
            ModuleType.Document,
            this.currentFilter.Settings,
            this.isSuperAdminAccess,
            this.isFilterSettingsShown,
        );
    }

    getItemsCountText(): string {
        let itemsCountText: string;
        const fetchedItemsCount = this.ListData.Data.length;
        if (this.loading && fetchedItemsCount === 0) {
            itemsCountText = '?';
        } else {
            // we don't fetch total items count so should implement tricky workaround
            if (
                this.ListData.TotalDataCount < Number.MAX_SAFE_INTEGER ||
                fetchedItemsCount < FiAppSettings.NumberOfRecordsPerPage
            ) {
                itemsCountText = fetchedItemsCount.toString();
            } else {
                itemsCountText = FiAppSettings.NumberOfRecordsPerPage.toString() + '+';
            }
        }

        return `${itemsCountText} ${this.appTextService
            .get(fiItemsListTypeNameTextId(FiItemsListType.Documents, fetchedItemsCount))
            .toLowerCase()}`;
    }
}
